import { render, staticRenderFns } from "./Tabbar.vue?vue&type=template&id=44378cb6&scoped=true"
import script from "./Tabbar.vue?vue&type=script&lang=js"
export * from "./Tabbar.vue?vue&type=script&lang=js"
import style0 from "./Tabbar.vue?vue&type=style&index=0&id=44378cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44378cb6",
  null
  
)

export default component.exports